<template>
    <div class="panel">
        <div class="panel-body">

            <template v-for="(item, index) in level2RecordArr">
                <el-row class="column-name" justify="start">
                    <span>{{level1RecordArr[index].config.category}}</span>
                    <div class="navbar-right">
                        得分：{{getLevel2Score(item)}}&nbsp&nbsp
                        <el-button type="info" plain size="minimum" v-if="canOper" @click="openLevel3(item)">操作</el-button>
                    </div>
                </el-row>
                <el-row class="bottom20">
                    <el-table :data="item">
                        <el-table-column prop="config.category" label="项目">
                        </el-table-column>
                        <el-table-column prop="config.weight" :formatter="formatWeight" label="权重">
                        </el-table-column>
                        <el-table-column prop="score" label="实得分值">
                        </el-table-column>
                        <el-table-column prop="deductscore" label="扣分值">
                            <template slot-scope="scope">
                                <div>
                                    <el-button @click="openLevel3([scope.row])" type="text" size="mini">
                                        {{ Math.abs(Number.parseFloat(scope.row.deductscore)) }}
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </template>

            <assessment-record-dialog
                    :level2CategoryArr="level2CategoryArr"
                    :level2SelectedCategoryIds="level2SelectedCategoryIds"
                    :tableData="level3RecordArr"
                    :assessmentRecordDialogVisible="assessmentRecordDialogVisible"
                    :readOnly="assessmentRecordReadOnlyFlag"
                    @afterCloseAssessmentRecordDialog="afterCloseAssessmentRecordDialog"></assessment-record-dialog>

        </div>
    </div>
</template>

<script>
    import AssessmentServer from "../../../api/assessment";
    import AssessmentRecordDialog from "./assessmentRecordDialog"
    import {debounce} from "../../../util/common";

    export default {
        name: "assessmentRecordLevel2Table",

        components: {
            AssessmentRecordDialog
        },

        props: ['assessmentid', 'canOper'],

        data() {
            return {

                assessmentRecordArr: [],

                level1RecordArr: [],

                level2RecordArr: [],

                level2CategoryArr: [],
                level2SelectedCategoryIds: [],  //默认全选
                level3RecordArr: [],

                assessmentRecordDialogVisible: false,   //扣分模态框是否显示

                assessmentRecordReadOnlyFlag: false,    //评分项是否只读

            }
        },

        mounted() {

        },

        methods: {

            getLevel2Score(row) {
                let level2Score = row.reduce(function (sum, item) {
                    return sum + item.score * item.config.weight * 0.01;
                }, 0);
                return Math.round(level2Score * 100) / 100;
            },

            queryAssetmentRecordLevel2Table(assessmentid) {

                let me = this;
                AssessmentServer.assessmentRecord.list({assessmentid: assessmentid}).then(responseBody => {
                    if (responseBody.data.code == 200) {
                        me.assessmentRecordArr = responseBody.data.data;
                        me.level1RecordArr = responseBody.data.data.filter(e => {
                            return e.config.level == 1;
                        });

                        me.level2RecordArr = [];
                        me.level1RecordArr.forEach(e => {
                            let l2 = new Array();
                            me.assessmentRecordArr.forEach(f => {
                                if (e.config.id == f.config.parent) {
                                    l2.push(f);
                                }
                            })
                            me.level2RecordArr.push(l2);
                        });
                    }
                });

            },

            openLevel3(item) {

                //过滤，仅显示属于选中第一层的所有第三层配置记录
                this.level2CategoryArr = [];
                this.level2SelectedCategoryIds = [];
                this.level3RecordArr = [];

                for (let i = 0; i < this.assessmentRecordArr.length; i++) {
                    for (let j = 0; j < item.length; j++) {
                        if (this.assessmentRecordArr[i].config.level == 3 && this.assessmentRecordArr[i].config.parent == item[j].config.id) {
                            this.assessmentRecordArr[i].deductscore = 0 - Number.parseFloat(this.assessmentRecordArr[i].deductscore);
                            this.level3RecordArr.push(this.assessmentRecordArr[i]);
                            break;
                        }
                    }
                    for (let j = 0; j < item.length; j++) {
                        if (this.assessmentRecordArr[i].config.level == 2 && this.assessmentRecordArr[i].config.id == item[j].config.id) {
                            this.level2CategoryArr.push(this.assessmentRecordArr[i]);
                            this.level2SelectedCategoryIds.push(this.assessmentRecordArr[i].config.id);
                            break;
                        }
                    }
                }

                this.sortRecordArr(this.level3RecordArr);

                if (this.canOper) {
                    this.assessmentRecordReadOnlyFlag = false;
                } else {
                    this.assessmentRecordReadOnlyFlag = true;
                }

                this.assessmentRecordDialogVisible = true;

            },

            sortRecordArr(assessmentRecordArr) {
                assessmentRecordArr.sort((a, b) => {
                    if (a.config.parent > b.config.parent) {
                        return 1;
                    } else if (a.config.parent < b.config.parent) {
                        return -1;
                    } else {
                        if (a.config.level > b.config.level) {
                            return 1;
                        } else if (a.config.level < b.config.level) {
                            return -1;
                        } else {
                            if (a.config.order > b.config.order) {
                                return 1;
                            } else if (a.config.order < b.config.order) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }
                    }
                });
            },

            afterCloseAssessmentRecordDialog() {
                this.assessmentRecordDialogVisible = false;
                this.queryAssetmentRecordLevel2Table(this.assessmentid);

                this.$emit('afterUpdateAssessmentRecord');

            },

            formatWeight(row, column) {
                if (row.config.weight != null) {
                    return `${row.config.weight}%`;
                } else {
                    return '';
                }
            },

        },

        watch: {
            assessmentid: {
                handler: debounce(function (newVal, oldVal) {
                    this.queryAssetmentRecordLevel2Table(newVal);
                }, 100)
            }
        },

    }

</script>

<style scoped>

</style>